import React from 'react';
import signupContext from 'src/constants/signupContext';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { trackEventWithFields } from 'src/utils/analytics';
import i18n from 'i18next';
import { connect } from 'react-redux';
import * as log from 'loglevel';

const FLOATING_BOX__KEY = '__hu_show_floating_box__';

const isVisible = () => {
  try {
    return !(localStorage && localStorage.getItem(FLOATING_BOX__KEY));
  } catch (e) {
    // For safari incognito
    log.debug(e);
  }
};


class FloatingBox extends React.Component {

  hide = () => {
    try {
      if (localStorage) {
        localStorage.setItem(FLOATING_BOX__KEY, true);
      }
    } catch (e) {
      // For safari incognito
      log.debug(e);
    }
    // force update to check updated local storage value
    this.forceUpdate();
  };

  handleDismiss = () => {
    this.hide();
    trackEventWithFields('Onboarding', 'Dismissed footer', this.props.communitySlug, undefined, { nonInteraction: true });
  }

  onSubmitEmail = (e, refName) => {
    e.preventDefault();
    this.props.showSignupModal({ section: signupContext.section.FLOATING_BOX }, null, false, this[refName].value);
  }

  render() {
    if (!isVisible()) {
      return null;
    }
    return <div className="floating-box" >
      <div className="floating-box-sign-up">
        <a className="floating-box-sign-up__dismiss icon-close" onClick={this.handleDismiss} />
        <div className="floating-box-sign-up__title" >
          {i18n.t('Join the no.1 health network')}
        </div>
        <div className="floating-box-sign-up__content" >
          <span className="hidden-xs" >{i18n.t('Get answers to all your health questions, latest news, information and support from people like you')}</span>
          <form className="floating-box-sign-up__content__form" onSubmit={e => this.onSubmitEmail(e, 'emailRef')}>
            <input
              className="form-control floating-box-sign-up__form-input--small"
              placeholder={i18n.t('email@address.com')}
              ref={node => (this.emailRef = node)}
              type="text"
            />
            <button className="floating-box-sign-up__button btn btn-primary btn-lg" type="submit">
              <span className="hidden-xs" >{i18n.t('Join HealthUnlocked')}</span>
              <span className="visible-xs" >{i18n.t('Join')}</span>
            </button>
          </form>
        </div>
      </div>
    </div>;
  }
}

export default connect(null, { showSignupModal })(FloatingBox);




// WEBPACK FOOTER //
// ./src/components/floatingSignupBox.js